import React from 'react';
import { CheckCircle, X, Clock } from 'lucide-react';

interface CampaignScheduledConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  scheduledAt: Date;
}

export function CampaignScheduledConfirmationModal({
  isOpen,
  onClose,
  scheduledAt,
}: CampaignScheduledConfirmationModalProps) {
  if (!isOpen) return null;

  const formattedDate = scheduledAt.toLocaleString('nl-NL', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-6">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
              <CheckCircle className="w-6 h-6 text-green-600" />
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-bold text-[#231F20] mb-2">
                Campaign ingepland
              </h2>
              <div className="space-y-3">
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                  <div className="flex items-start gap-2">
                    <Clock className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="text-sm font-semibold text-blue-900 mb-1">
                        Ingepland voor:
                      </p>
                      <p className="text-sm text-blue-800">
                        {formattedDate}
                      </p>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-600">
                  Je kunt deze nog annuleren voordat deze verstuurd wordt.
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="btn-primary"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
